export const EmailAutomationRoutes = {
  LIST: "/email-automations",
  CREATE: "/email-automations/new",
  EDIT: "/email-automations/:id",
  SENDS: "/email-automations/:id/sends",
} as const;
